import { Component, OnInit } from '@angular/core'

import { NUMBER_ZERO } from '../../../../../constants/constant.numbers'
import { ObservableService } from '../../../../services/observable-service/observable.service'
import { FilterModel } from '../../../../shared/filter-model'

@Component({
  selector: 'equity-sub-asset-filter',
  templateUrl: './equity-sub-asset-filter.component.html',
  styleUrls: ['./equity-sub-asset-filter.component.scss'],
})
export class EquitySubAssetFilterComponent implements OnInit {
  filter
  selectedProductType: string
  constructor(
    private filterModel: FilterModel,
    private readonly observableService: ObservableService,
  ) {}
  ngOnInit() {
    this.filterModel.telecastFilterBy.subscribe((data) => {
      this.filter = data
    })
    this.observableService.viewProductClickValue.subscribe((value) => {
      this.selectedProductType = value
    })
  }
  equityRegionStateChange(event: any) {
    let subAssetSelectionCount = NUMBER_ZERO
    this.filter.filterByLevel1.equity.level2.forEach((obj) => {
      if (obj.id === event.target.id) {
        obj.value = event.target.checked
      }
      if (obj.value) {
        subAssetSelectionCount++
      }
    })
    this.filterModel.setSubAssetSelectedCount(subAssetSelectionCount)
    this.filterModel.editDataFilterBy(this.filter)
  }

  checkAvailability(args: string[]) {
    return args.includes(this.selectedProductType)
  }
}
